__webpack_require__.p = "/frisbeeapuri/";